/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { ErrorMessage, Formik, FormikHelpers } from "formik";
import React, { useCallback, useEffect, useRef, useState } from "react";

import * as Yup from "yup";

import { Button } from "primereact/button";
import { Calendar, CalendarChangeEvent } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";

import { useHistory, useParams } from "react-router-dom";

import { FileUpload } from "primereact/fileupload";
import api from "../../../services/api";

import { useToast } from "../../../hooks/toast";

import { Container } from "./styles";

interface LawsuitAgreementUpdateData {
  pac_id: number;
  pac_data: Date;
  pac_obs: string;
  advogado_id: number;
  nivel_acesso: string;
  and_arquivo: string;
}

const AddEditLawsuitAgreementUpdate: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const { id } = useParams<{ id: string }>();
  const isAddMode = !id;

  const [activeIndex, setActiveIndex] = useState(0);
  const [currentLawsuit, setCurrentLawsuit] = useState(0);
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const cod = params.get("cod");
  const activeTab = params.get("active");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileUploadRef = useRef<any>(null);
  const [selectedFile, setSelectedFile] = useState(null);

  let loggedUserLevel = "";
  let loggedUserId = 0;

  const accessData = localStorage.getItem("@Jurisnet:access");

  if (typeof accessData === "string") {
    const access = JSON.parse(accessData);
    loggedUserLevel = access.nivelusuario;
    loggedUserId = Number(access.usuario_logado);
  }

  // control tab changes when leaving/returning to page
  useEffect(() => {
    if (activeTab !== undefined || activeTab !== null) {
      setActiveIndex(Number(activeTab));
    }
    if (cod !== undefined || cod !== null) {
      setCurrentLawsuit(Number(cod));
    }
  }, [activeTab, cod]);

  const initialValues: LawsuitAgreementUpdateData = {
    pac_id: Number(cod),
    pac_data: new Date(),
    pac_obs: "",
    advogado_id: loggedUserId,
    nivel_acesso: loggedUserLevel,
    and_arquivo: "",
  };

  const returnLawsuitURL = `/lawsuit/main/edit/${currentLawsuit}?active=${activeIndex}`;

  const validationSchema = Yup.object().shape({
    pac_obs: Yup.string().required("Descrição obrigatória"),
  });

  const handleCancel = () => {
    history.push(returnLawsuitURL);
  };

  const handleOnSubmit = async (
    values: LawsuitAgreementUpdateData,
    { setSubmitting }: FormikHelpers<LawsuitAgreementUpdateData>
  ) => {
    if (isAddMode) {
      try {
        const formData = {
          proc_id: Number(cod),
          pac_data: agreementUpdateDate,
          pac_obs: values.pac_obs,
          advogado_id: loggedUserId,
          nivel_acesso: loggedUserLevel,
          and_arquivo: "",
        };

        if (selectedFile && values.and_arquivo === "") {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(selectedFile);
        }

        await api
          .post("/lawsuits/agreementupdates/create", formData)
          .then(async (response) => {
            setSubmitting(false);

            if (selectedFile && values.and_arquivo === "") {
              const data = new FormData();

              data.append("pac_id", response.data.pac_id);
              if (selectedFile) {
                data.append("and_arquivo", selectedFile);
              } else {
                data.append("arquivo", values.and_arquivo);
              }

              try {
                await api.patch("/lawsuits/agreementupdates/file", data);

                addToast({
                  type: "info",
                  title: "Upload concluído!",
                  description: "Arquivo enviado com sucesso.",
                });
              } catch (error) {
                addToast({
                  type: "error",
                  title: "Ocorreu um problema no upload",
                  description: "O arquivo não foi enviado. Tente novamente.",
                });
              }
            }
          });

        addToast({
          type: "success",
          title: "Cadastro atualizado!",
          description:
            "As informações do cadastro foram atualizadas com sucesso.",
        });

        history.push(
          `/lawsuit/main/edit/${currentLawsuit}?active=${activeIndex}`
        );
      } catch (error) {
        addToast({
          type: "error",
          title: "Ocorreu um problema",
          description: "Tente repetir o cadastro ou contate o administrador.",
        });
      }
    } else {
      try {
        if (selectedFile && values.and_arquivo === "") {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(selectedFile);
        }

        const formData = {
          proc_id: Number(cod),
          pac_data: agreementUpdateDate,
          pac_obs: values.pac_obs,
          advogado_id: loggedUserId,
          nivel_acesso: loggedUserLevel,
          and_arquivo: values.and_arquivo === "" ? "" : values.and_arquivo,
        };

        await api.put(`/lawsuits/agreementupdates/edit/${id}`, formData);

        addToast({
          type: "success",
          title: "Cadastro atualizado!",
          description:
            "As informações do cadastro foram atualizadas com sucesso.",
        });

        if (selectedFile && values.and_arquivo === "") {
          const data = new FormData();

          data.append("pac_id", id);
          if (selectedFile) {
            data.append("and_arquivo", selectedFile);
          } else {
            data.append("arquivo", values.and_arquivo);
          }

          try {
            await api.patch("/lawsuits/agreementupdates/file", data);

            addToast({
              type: "info",
              title: "Upload concluído!",
              description: "Arquivo enviado com sucesso.",
            });
          } catch (error) {
            addToast({
              type: "error",
              title: "Ocorreu um problema no upload",
              description: "O arquivo não foi enviado. Tente novamente.",
            });
          }
        }

        setSubmitting(false);

        history.push(
          `/lawsuit/main/edit/${currentLawsuit}?active=${activeIndex}`
        );
      } catch (error) {
        addToast({
          type: "error",
          title: "Ocorreu um problema",
          description: `Tente repetir o cadastro ou contate o administrador. ${error}`,
        });
      }
    }
  };

  const [updatedate, setUpdateDatees] = useState(null);
  const [agreementUpdateDate, setAgreementUpdateDate] = useState<
    string | Date | Date[] | null
  >(new Date());

  const handleFileDelete = async (values: LawsuitAgreementUpdateData) => {
    try {
      const data = new FormData();

      data.append("pac_id", id);
      data.append("arquivo", values.and_arquivo);

      await api.patch("/lawsuits/agreementupdates/file", data);

      addToast({
        type: "info",
        title: "Arquivo excluído!",
        description: "Arquivo excluído com sucesso.",
      });
    } catch (error) {
      addToast({
        type: "error",
        title: "Ocorreu um problema",
        description: "O arquivo não foi encontrado para ser excluído.",
      });
    }
  };

  const handleSetFile = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: { files: any[] }) => {
      setSelectedFile(e.files[0]);
    },
    []
  );

  const handleFileChange = useCallback((e) => {
    if (e.files.length > 0) {
      setSelectedFile(e.files[0]);
    }
  }, []);

  return (
    <Container>
      <header>
        <div className="flex align-content-center justify-content-center">
          <h2>
            {isAddMode ? "Cadastrar " : "Editar "} atualização de contrato
          </h2>
        </div>
      </header>

      <div className="card">
        <header>
          <h3>Dados Cadastrais Obrigatórios</h3>
        </header>

        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={validationSchema}
          initialValues={updatedate || initialValues}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            setValues,
            setFieldValue,
          }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useEffect(() => {
              try {
                if (!isAddMode) {
                  api
                    .get(`/lawsuits/agreementupdates/show/${id}`)
                    .then(async (response) => {
                      setUpdateDatees(response.data);
                      setValues(response.data);

                      if (response.data.pac_data !== null) {
                        const current = new Date(response.data.pac_data);
                        const utc = new Date(
                          current.getTime() +
                            current.getTimezoneOffset() * 60000
                        );

                        setAgreementUpdateDate(new Date(utc));
                      }
                    });
                }
              } catch (e) {
                addToast({
                  type: "error",
                  title: "Ocorreu um problema",
                  description:
                    "Não foi possível carregar as informações do cadastro selecionado.",
                });
              }
            }, [setValues]);
            return (
              <form onSubmit={handleSubmit}>
                <div className="fluid formgrid grid">
                  <div className="col-12">
                    <div className="field grid">
                      <div className="col-12 md:col-3">
                        <label htmlFor="pac_data">Data *</label>
                        <Calendar
                          inputId="pac_data"
                          name="pac_data"
                          className="inputfield w-full"
                          value={agreementUpdateDate}
                          onChange={(e: CalendarChangeEvent) => {
                            if (e.value !== undefined && e.value !== null) {
                              setAgreementUpdateDate(e.value);
                            }
                          }}
                          onBlur={handleBlur}
                          keepInvalid
                          showIcon
                          showButtonBar
                          showOnFocus={false}
                          mask="99/99/9999"
                          dateFormat="dd/mm/yy"
                          yearRange="1980:2030"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="field grid">
                    <div className="col-12 md:col-12">
                      <div className="col-12 md:col-12">
                        <label htmlFor="pac_obs">
                          Descrição do andamento *
                        </label>
                        <InputTextarea
                          id="pac_obs"
                          name="pac_obs"
                          className="inputfield w-full"
                          value={values.pac_obs}
                          onChange={handleChange}
                          rows={5}
                          cols={30}
                        />
                        <ErrorMessage name="pac_obs">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </div>
                      {values.and_arquivo === "" ? (
                        <div className="col-12 md:col-12">
                          <label htmlFor="and_arquivo">
                            Arquivo para anexar com o andamento
                          </label>
                          <FileUpload
                            ref={fileUploadRef}
                            multiple={false}
                            mode="basic"
                            name="and_arquivo[]"
                            id="and_arquivo"
                            accept=".doc,.docx,.pdf,.jpeg,.jpg"
                            maxFileSize={15000000}
                            chooseLabel="CLIQUE AQUI para selecionar arquivo para upload"
                            onSelect={(e) => handleSetFile(e)}
                            customUpload
                            uploadHandler={handleFileChange}
                          />
                        </div>
                      ) : (
                        <div className="col-12 md:col-12">
                          Arquivo anexo:{" "}
                          <span className="p-mr-2 red">
                            {values.and_arquivo}
                          </span>
                          <Button
                            icon="pi pi-trash"
                            tooltip="Excluir cadastro"
                            tooltipOptions={{ position: "left" }}
                            className="p-button-rounded p-button-warning"
                            title="Excluir este arquivo"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileDelete(values);
                              setFieldValue("and_arquivo", "");
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12 p-mt-20">
                    <div className="col-12">
                      Todos os campos marcados com * são de preenchimento
                      obrigatório.
                    </div>
                    <header />
                    <div className="flex align-content-center justify-content-center field">
                      <Button
                        icon="pi pi-check"
                        iconPos="left"
                        label="Enviar dados"
                        className="p-mr-2"
                        type="submit"
                      />
                      <Button
                        icon="pi pi-undo"
                        iconPos="left"
                        label="Limpar campos"
                        className="p-button-secondary p-mr-2"
                        type="button"
                        onClick={handleReset}
                      />
                      <Button
                        icon="pi pi-times"
                        iconPos="left"
                        label="Cancelar e voltar"
                        className="p-button-danger"
                        type="button"
                        onClick={handleCancel}
                      />
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </Container>
  );
};

export default AddEditLawsuitAgreementUpdate;
